import React from "react";
import { useParams, Link } from "react-router-dom";
import "./PaymentSuccess.css";

const PaymentSuccess = () => {
  const { invoiceId } = useParams();

  return (
    <div className="success-container">
      <div className="logo-container">
        <img src="/ihub-logo.png" alt="iHub Logo" className="ihub-logo" />
      </div>

      <div className="success-content">
        <div className="success-icon">✓</div>
        <h2>Payment Successful!</h2>
        <p>
          Your payment for invoice <strong>{invoiceId}</strong> has been
          processed successfully.
        </p>
        <p>Thank you for your payment.</p>
        <Link to="https://ihub.co.ke" className="home-button">
          Return To iHUB
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;
